export const SIGNER_DATA_DISPLAY = {
  BEFORE_PREVIEW: 'beforepreview',
  AFTER_PREVIEW: 'afterpreview',
};

/**
 * Normalize SignerData.Display.
 *
 * Acceptance:
 * - Absent / null / invalid => default BEFORE_PREVIEW
 * - Recognized values: BeforePreview | AfterPreview (case-insensitive)
 */
export const normalizeSignerDataDisplay = (signerData) => {
  const raw = signerData?.Display;

  if (typeof raw !== 'string') return SIGNER_DATA_DISPLAY.BEFORE_PREVIEW;

  const value = raw.trim().toLowerCase();
  if (value === SIGNER_DATA_DISPLAY.AFTER_PREVIEW) return SIGNER_DATA_DISPLAY.AFTER_PREVIEW;
  if (value === SIGNER_DATA_DISPLAY.BEFORE_PREVIEW) return SIGNER_DATA_DISPLAY.BEFORE_PREVIEW;

  return SIGNER_DATA_DISPLAY.BEFORE_PREVIEW;
};

export const shouldShowSignerDataBeforePreview = (signerData) => {
  return !!signerData && normalizeSignerDataDisplay(signerData) === SIGNER_DATA_DISPLAY.BEFORE_PREVIEW;
};

export const shouldShowSignerDataAfterPreview = (signerData) => {
  return !!signerData && normalizeSignerDataDisplay(signerData) === SIGNER_DATA_DISPLAY.AFTER_PREVIEW;
};

